import React from 'react';
import { store } from '../../../../store'

class FontPicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    customization: store.getState().customization.custom,
    font: '',
    size: '',
    nameFont: '',
    nameSize: '',
    bioFont: '',
    bioSize: '',
    selectProfile: ''
    }
}
  componentDidMount() {
let { customization } = store.getState()
  this.setState({customization: customization.custom})
    customization.custom.map((value,i) => {
        if(value.class === customization.select) {
        this.setState({
          font: value.font,
          size: value.size
        })
        }
        if(value.class === 'profile_name') {
        this.setState({
          nameFont: value.font,
          nameSize: value.size
        })
        }
        if(value.class === 'profile_bio') {
        this.setState({
          bioFont: value.font,
          bioSize: value.size
        })
        }
  })
}
  render() {
let { customization } = store.getState()
const handleChange = (e, check) =>
{
  let customizationElement = null

  let arr = this.state.customization;

  arr.map((value,i) => {
    if(customization.select === 'profile' && value.class === this.state.selectProfile) {
        if(check === 'font') {

          if(this.state.selectProfile === 'profile_name') {
            this.setState({nameFont: e.target.value})
          }
          else {
            this.setState({bioFont: e.target.value})
          }
          arr[i].font = e.target.value
          }

        else {
          if(value.class === 'profile_name') {
            this.setState({nameSize: e.target.value})
          }
          else {
            this.setState({bioSize: e.target.value})
          }
        
          arr[i].size = e.target.value
        }
      }

      if(value.class === customization.select) {

        if(check === 'font') {
          this.setState({font: e.target.value})
          arr[i].font = e.target.value
        }

        else {
          this.setState({size: e.target.value})
          arr[i].size = e.target.value
        }
      }

        })

  this.props.onCustomization(arr)
  this.setState({customization:arr})

        // if(flag === 0)
        // {
        //   let custarr = this.state.customization
        //   let concatedcustarray = custarr.concat(customizationElement)
        //   this.props.onCustomization(concatedcustarray)
        //   this.setState({customization:concatedcustarray})
        // }
}
  if(customization.select === 'profile') {
    return(   
      <div>
  <div className="font_picker" onMouseOver={()=>this.setState({selectProfile: 'profile_name'})}>
    <div className="select_custom">
        <span className="select_custom_head">Profile Name Fonts</span>
        <span className="select_custom_label">Font</span>
        <select className="select_font" 
    value={this.state.nameFont}
    onChange={(e,check)=>handleChange(e,'font')} 
    selectedValue={this.state.nameFont}
              > 
                    <option value="oswald">Oswald</option>
                    <option value="Open Sans">Open Sans</option>
                    <option value="roboto">Roboto</option>
                    <option value="Roboto Mono">Roboto Mono</option>
                    <option value="Lato">Lato</option>
                    <option value="Righteous">Righteous</option>
                    <option value="Vibur">Vibur</option>
                    <option value="Shadows into light two">Shadows into light two</option>
                    <option value="Dancing Script">Dancing Script</option>
                    <option value="Pacifico">Pacifico</option>
                    <option value="Lobster 2">Lobster 2</option>
                    <option value="Indie Flower">Indie Flower</option>
                    <option value="Merriweather">Merriweather</option>
                    <option value="Coiny">Coiny</option>
                    <option value="Lora">Lora</option>
                    <option value="Abel">Abel</option>
              </select>
      </div>
    <div className="select_custom">
        <span className="select_custom_label">Font Size</span>
        <div className="range_outside">
    <input type="range" min="8" max="92" value="50" className="slider" id="myRange" 
    value={this.state.nameSize}
    onChange={(e,check)=>handleChange(e,'size')} 
    selectedValue={this.state.nameSize} />
    <span className="range_output">{this.state.nameSize}</span>
    </div>
    </div>
    </div>
    <div className="font_picker" onMouseOver={()=>this.setState({selectProfile: 'profile_bio'})}>
    <div className="select_custom">
        <span className="select_custom_head">Profile Bio Fonts</span>
        <span className="select_custom_label">Font</span>
        <select className="select_font" 
    value={this.state.bioFont}
    onChange={(e,check)=>handleChange(e,'font')} 
    selectedValue={this.state.bioFont}
              > 
                    <option value="oswald">Oswald</option>
                    <option value="Open Sans">Open Sans</option>
                    <option value="roboto">Roboto</option>
                    <option value="Roboto Mono">Roboto Mono</option>
                    <option value="Lato">Lato</option>
                    <option value="Righteous">Righteous</option>
                    <option value="Vibur">Vibur</option>
                    <option value="Shadows into light two">Shadows into light two</option>
                    <option value="Dancing Script">Dancing Script</option>
                    <option value="Pacifico">Pacifico</option>
                    <option value="Lobster 2">Lobster 2</option>
                    <option value="Indie Flower">Indie Flower</option>
                    <option value="Merriweather">Merriweather</option>
                    <option value="Coiny">Coiny</option>
                    <option value="Lora">Lora</option>
                    <option value="Abel">Abel</option>
              </select>
      </div>
    <div className="select_custom">
        <span className="select_custom_label">Font Size</span>

        <div className="range_outside">
    <input type="range" min="8" max="92" value="50" className="slider"
    value={this.state.bioSize}
    onChange={(e,check)=>handleChange(e,'size')} 
    selectedValue={this.state.bioSize} />
    <span className="range_output">{this.state.bioSize}</span>
    </div>
    </div>

      </div>
      </div>)
}
    return(   
  <div className="font_picker">
    <div className="select_custom">
        <span className="select_custom_head">About Section</span>
        <span className="select_custom_label">Font</span>
        <select className="select_font" 
    value={this.state.font}
    onChange={(e,check)=>handleChange(e,'font')} 
    selectedValue={this.state.font}
              > 
                    <option value="oswald">Oswald</option>
                    <option value="Open Sans">Open Sans</option>
                    <option value="roboto">Roboto</option>
                    <option value="Roboto Mono">Roboto Mono</option>
                    <option value="Lato">Lato</option>
                    <option value="Righteous">Righteous</option>
                    <option value="Vibur">Vibur</option>
                    <option value="Shadows into light two">Shadows into light two</option>
                    <option value="Dancing Script">Dancing Script</option>
                    <option value="Pacifico">Pacifico</option>
                    <option value="Lobster 2">Lobster 2</option>
                    <option value="Indie Flower">Indie Flower</option>
                    <option value="Merriweather">Merriweather</option>
                    <option value="Coiny">Coiny</option>
                    <option value="Lora">Lora</option>
                    <option value="Abel">Abel</option>
              </select>
      </div>
    <div className="select_custom">
        <span className="select_custom_label">Font Size</span>

        <div className="range_outside">
    <input type="range" min="8" max="92" value="50" className="slider"
    value={this.state.size}
    onChange={(e,check)=>handleChange(e,'size')} 
    selectedValue={this.state.size}/>
    <span className="range_output">{this.state.size}</span>
    </div>
    </div>
      </div>)
}
}
export default FontPicker